// Small pure helpers of the library and calendar pages (kept apart so they can be tested).

export const TAG_TYPES = ["STYLE", "EQUIPMENT", "FOCUS", "BODY_AREA"];

/** Duration buttons: minutes, as the server filters them. */
export const DURATION_PRESETS = [
  { label: "lib.dur.short", max: 15 },
  { label: "lib.dur.medium", min: 15, max: 30 },
  { label: "lib.dur.long", min: 30, max: 45 },
  { label: "lib.dur.xl", min: 45 },
];

export const LEVELS = { BEGINNER: "lib.level.BEGINNER", INTERMEDIATE: "lib.level.INTERMEDIATE", ADVANCED: "lib.level.ADVANCED" };

/** "12:05", "1:02:30". */
export function durationLabel(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const two = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${two(m)}:${two(sec)}` : `${m}:${two(sec)}`;
}

/** The chosen tag ids after clicking one: added when absent, removed when present. */
export function nextTags(current, id) {
  return current.indexOf(id) >= 0 ? current.filter((x) => x !== id) : [...current, id];
}

/** "2026-10" for a month and a step (+1 / -1). */
export function shiftMonth(month, step) {
  const [y, m] = month.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + step, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}

/** The cells of a month grid: leading blanks, then every day as "YYYY-MM-DD". weekStart 0 = Sunday ... 6 = Saturday. */
export function monthCells(month, weekStart) {
  const [y, m] = month.split("-").map(Number);
  const first = new Date(Date.UTC(y, m - 1, 1));
  const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const lead = (first.getUTCDay() - weekStart + 7) % 7;
  const cells = Array(lead).fill(null);
  for (let d = 1; d <= days; d++) cells.push(`${month}-${String(d).padStart(2, "0")}`);
  return cells;
}

/** Entries grouped by their day. */
export function byDay(entries) {
  const map = {};
  (entries || []).forEach((e) => {
    (map[e.day] = map[e.day] || []).push(e);
  });
  return map;
}

/** Today as YYYY-MM-DD in Cairo (where the coaches are), whatever the browser's own zone. */
export function todayCairo(now = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Africa/Cairo", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}
